import { render, staticRenderFns } from "./PodcastDetails.vue?vue&type=template&id=58d1d3f1&"
import script from "./PodcastDetails.vue?vue&type=script&lang=ts&"
export * from "./PodcastDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports